import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetTypeCatalog = async (entityType) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/TypeCatalog/get?typeCatalogID=0&entityType=${entityType}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
}

export const SaveTypeCatalog = async (typeCatalog) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/TypeCatalog/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(typeCatalog),
      });
      
      const data = await response.json();                      
      
      if (response.ok && !data.isError) {      
        return data;
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
}; 

export const DeleteTypeCatalog = async (typeCatalogID, entityType = "Asset") => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/TypeCatalog/delete?typeCatalogID=${typeCatalogID}&entityType=${entityType}`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const data = await response.json();
      if (response.ok && !data.isError) {
        return data;
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};